export default __webpack_public_path__ + "static/media/Lock.e846db0a.svg";